var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content"},[_c('Slider',{attrs:{"slides":_vm.slides},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var currentSlide = ref.currentSlide;
return [_c('img',{attrs:{"alt":currentSlide.title,"title":currentSlide.title,"src":currentSlide.img}})]}}])}),_c('router-view'),_c('TheContact')],1)}
var staticRenderFns = []

export { render, staticRenderFns }